// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"2166":"css/app.6720","3971":"css/admin-app.6720"}[chunkId] + ".css";
};